import React, {Component, useState, useEffect} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom'; 
import Header from '../common/Header'; 
import Footer from '../common/Footer';
import PageHeader from '../components/PageHeader'; 
import withRouter from '../components/withRouter';
import ResetContent, {AppWithRouter} from './components/ResetContent';

class UserReset extends React.Component{

    constructor(){
        super();  
    }
 
    render()
    { 
        return (
            <div>
                <Header/> 
                <PageHeader title="Reset Password" />
                <AppWithRouter token={this.props.params.token}   />  
                <Footer/>
            </div>
        )
    }
}
export default withRouter(UserReset);;